export const SITE_INSTALL_TESTS_CARD_FRENCH_LOCALE = {
  title: "Tests d'installation",
  tabs: {
    vx: "Tests matériels Vx ({count} tests)",
    v2v5: "Tests matériels V2/V5 ({count} tests)",
  },
};
